import { ChipsSkeleton, DetailsCardSkeleton, RedeemBarSkeleton, SkeletonBlock } from "./DiscountDetailsSkeleton.shared";

export default function DiscountDetailsSkeletonMob() {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="rounded-xs outline-border-subtle flex flex-col overflow-hidden outline">
        <div className="p-4">
          <DetailsCardSkeleton />
        </div>
        <div className="p-4">
          <ChipsSkeleton />
        </div>
      </div>
      <div className="flex w-full flex-col gap-3">
        {["w-24", "w-36"].map((width) => (
          <div key={width} className="outline-border-subtle flex w-full items-center gap-3 rounded-xl p-4 outline">
            <SkeletonBlock className="size-10 shrink-0 rounded-full" />
            <div className="flex-1">
              <SkeletonBlock className={`h-4 ${width}`} />
            </div>
            <SkeletonBlock className="size-5 shrink-0" />
          </div>
        ))}
      </div>
      <div className="shadow-bottom-sheet bg-background-default fixed start-0 end-0 bottom-0 z-50 rounded-t-xl p-4">
        <RedeemBarSkeleton />
      </div>
    </div>
  );
}
